<template>
    <div class="customer">
        <tenders-stat-table
            v-if="years.length"
            type="customers"
            :years="years.slice().reverse()"
            :stat="stat" 
            ref="table"
        />
        <tenders-tile-charts 
            v-if="stat && productsStat && years.length"
            :years="years" 
            :stat="stat"
            :productsStat="productsStat" 
            type="customers" 
        />
    </div>
</template>

<script>
import tendersStatTable from '@/components/card/tenders/tendersStatTable.vue'
import tendersTileCharts from '@/components/card/tenders/tendersTileCharts.vue'

export default {
    components: {
        tendersStatTable,
        tendersTileCharts
    },
    computed: {
        years() { return this.$store.getters['card/tenders/customerYears'] },
        stat() { return this.$store.state.card?.tenders?.stats?.customer || {} },
        productsStat() { return this.$store.state.card?.tenders?.productsStat?.customer }
    }
}
</script>

<style lang="sass" scoped>

</style>